(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name fuel.service:fuelPricesService
     *
     * @description
     *
     */
    angular
        .module('fuel')
        .service('FuelPricesService', FuelPricesService);

    function FuelPricesService(CommonFuelService, FuelRequestFactory, RemoteService) {
        var self = this;

        var model={
            pricesSearchCriteria: FuelRequestFactory.getFuelPriceSearchCriteria(),
            pricesList:[],
            supplierCopy:[]
        };

        self.setPricesSearchCriteria = function (passPriceSearch) {
            //TODO format and store searchParams
            var priceSearch = FuelRequestFactory.getFuelPriceSearchCriteria();
            priceSearch.startPosition = passPriceSearch.startPosition;
            priceSearch.pageSize = passPriceSearch.pageSize;
            if(passPriceSearch.airport.airPortCode==="ANY"){
                priceSearch.airportCode = null;
            }else{
                priceSearch.airportCode = passPriceSearch.airport.airPortCode;
            }
            model.pricesSearchCriteria = priceSearch;
        };

        self.getPricesSearchCriteria = function () {
            return model.pricesSearchCriteria;
        };
        
        self.getNewPrice = function () {
            return FuelRequestFactory.getFuelPriceSaveReq();
        };
        
        self.setSupplierCopy = function (supplier) {
            model.supplierCopy = supplier;
        };

        self.getFuelPriceForEdit = function(fuelPrice){
            var editPrice = FuelRequestFactory.getFuelPriceForSave(fuelPrice);
            editPrice.airportCode = {airPortCode:fuelPrice.airportCode};
            editPrice.fuelSupplierId = fuelPrice.supplier;
            return editPrice;
        };

        self.getFuelPrices = function(successFn, errorFn){
            RemoteService.searchFuelPrices(model.pricesSearchCriteria).then(
                function (response) {
                    if(response.success && !!response.fuelPriceList){
                        model.pricesList = FuelRequestFactory.getFormattedPrices(response.fuelPriceList, model.supplierCopy);
                        successFn(model.pricesList);
                    }
                },
                function (error) {
                    errorFn(error.msg[0]);
                }
            );
        };
        
        self.saveFuelPrice = function (fuelPrice, successFn, errorFn) {
            var saveSupplier = FuelRequestFactory.getFuelPriceForSave(fuelPrice);
            RemoteService.saveFuelPrices(saveSupplier).then(
                function (response) {
                    successFn(response);
                },
                function (error) {
                    errorFn(error.msg[0]);
                }
            );
        };
        
        self.deleteFuelPrice = function (fuelPrice, successFn, errorFn) {
            var deletePrice = FuelRequestFactory.getFuelPriceDeleteReq(fuelPrice);
            RemoteService.deleteFuelPrices(deletePrice).then(
                function (response) {
                    successFn(response);
                },
                function (error) {
                    errorFn(error.msg[0]);
                }
            );
        };
        
        self.getSupplierByAirport = function (airport) {
            var suppList = [];
            _.each(model.supplierCopy, function (sup) {
                if(sup.airportCode===airport){
                    suppList.push(sup);
                }
            });
            return suppList;
        };

        self.getFormattedFuelSuppliers = function (suppliers) {
            var suppliersArray = [];
            _.each(suppliers, function (sup) {
                var newSupplier = {};
                newSupplier.fuelSupplierId = sup.fuelSupplierId;
                newSupplier.title = sup.companyName + " (" + sup.companyAbbr + ")";
                newSupplier.airportCode = sup.city;
                suppliersArray.push(newSupplier);
            });
            return suppliersArray;
        };

        self.getFuelSuppliers = function(params, successFn, errorFn) {
            RemoteService.searchFuelSuppliers(params).then(
                function (response) {
                    if(response.success && !!response.fuelSupplierInfoCollection){
                        successFn(self.getFormattedFuelSuppliers(response.fuelSupplierInfoCollection));
                    }
                },
                function (error) {
                    errorFn(error);
                }
            );
        };

    }
})();